import { Expose } from 'class-transformer';

import { SnModel } from '../../../../../common/src/lib/models/model';

export class SnCameraStatusHistorical extends SnModel {
  @Expose()
  public id: number;

  @Expose()
  public status: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string[];

  @Expose()
  public camera: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
